export class DialogModelDROpenItemsSlotFilter {
    constructor(
        private data: any
    ) {}
  }